export const parseSystemResponseDetails = (
  details: unknown
): Record<string, unknown> => {
  if (!details) return {};

  if (typeof details === 'string') {
    try {
      return JSON.parse(details);
    } catch {
      return {};
    }
  }

  if (typeof details === 'object') {
    return details as Record<string, unknown>;
  }

  return {};
};
